var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuggestApp = function SvgSuggestApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 73,
    viewBox: "0 0 64 73"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.2.282h10.718V11H.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .249h21.378v21.378H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7488",
    fillRule: "nonzero",
    d: "M25.805 0a8.6 8.6 0 0 1 8.601 8.602v2.15H47.31a4.3 4.3 0 0 1 4.3 4.3v12.903h2.151a8.602 8.602 0 0 1 0 17.203h-2.15v12.903a4.3 4.3 0 0 1-4.301 4.3H34.406v-2.15a8.6 8.6 0 0 0-8.172-8.59l-.43-.011a8.6 8.6 0 0 0-8.59 8.172l-.01.43v2.15H4.3A4.3 4.3 0 0 1 0 58.06V45.158h2.15a8.6 8.6 0 0 0 8.592-8.172l.01-.43a8.6 8.6 0 0 0-8.172-8.59l-.43-.01H0V15.052a4.3 4.3 0 0 1 4.3-4.301h12.903v-2.15a8.6 8.6 0 0 1 8.602-8.602z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD1EF",
    fillRule: "nonzero",
    d: "m55.864 62.16-2.606 2.669-5.36-5.233 2.607-2.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5BFE2",
    fillRule: "nonzero",
    d: "m57.407 64.794.55-.564-5.36-5.233-.55.564z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53 61.751)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC64",
    fillRule: "nonzero",
    d: "m9.95 9.926-.105.104a3.31 3.31 0 0 1-4.68 0L1.17 6.036a3.31 3.31 0 0 1 0-4.68l.103-.105a3.31 3.31 0 0 1 4.682 0L9.95 5.245a3.31 3.31 0 0 1 0 4.681",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CA62",
    fillRule: "nonzero",
    d: "m62.932 66.978-3.994-3.994a3.31 3.31 0 0 0-3.961-.547s1.59-.305 3.333 1.314c1.743 1.622 3.994 3.995 3.994 3.995a3.304 3.304 0 0 1 .482 4.052q.021-.016.042-.034l.104-.104a3.31 3.31 0 0 0 0-4.681"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34 42.751)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B5BFE2",
    fillRule: "nonzero",
    d: "M21.378 10.938c0 5.903-4.785 10.689-10.688 10.689C4.785 21.627 0 16.841 0 10.938S4.785.249 10.69.249c5.903 0 10.688 4.786 10.688 10.689",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0F9",
    fillRule: "nonzero",
    d: "M53.436 53.689a8.87 8.87 0 1 1-17.739-.001 8.87 8.87 0 0 1 17.739.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CBD1EF",
    d: "M53.436 53.689a8.87 8.87 0 1 1-17.739-.001 8.87 8.87 0 0 1 17.739.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7683B5",
    fillRule: "nonzero",
    d: "M42.349 53.401a1.314 1.314 0 1 1-2.629-.001 1.314 1.314 0 0 1 2.629.001m3.849.337a.977.977 0 1 1-1.953 0 .977.977 0 0 1 1.953 0m3.208.292a.686.686 0 1 1-1.373-.003.686.686 0 0 1 1.373.003"
  }))));
};
export default SvgSuggestApp;